/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { Description, Image, Highlight } from '../../components/layouts';
import { Grid } from 'semantic-ui-react';
import { buildImageURL, pureTrans } from '../../helpers';

const isWebp = document.querySelector('html').classList.contains('webpSupport');

const IMAGES = {
  i1: isWebp ? buildImageURL('/s14-3.webp') : buildImageURL('/s14-3.jpg'),
  i2: isWebp ? buildImageURL('/s14-2.webp') : buildImageURL('/s14-2.jpg')
};

export default function DesktopContent({ progress }) {
  const { c1, c2, c3, d1, d2, d3 } = useMemo(() => {
    return {
      c1: pureTrans(progress, [-1, 0], [0.1, 1], 3),
      c2: pureTrans(progress, [-1, 0], [10, 0], 3),
      c3: pureTrans(progress, [-1, 0], [0.95, 1], 3),
      d1: pureTrans(progress, [-1, -0.2], [0.1, 1], 3),
      d2: pureTrans(progress, [-1, 0.5], [50, -50], 3),
      d3: pureTrans(progress, [-1, -0.2], [0.95, 1], 3)
    };
  }, [progress]);
  return (
    <Grid columns={2} className="section-content s14-b-2">
      <Grid.Column className="s14-b2-left">
        <div style={{ opacity: c1, transform: `translateY(${c2}%) scale(${c3}) translateZ(0)` }}>
          <Image paddingBottom="132.359%" src={IMAGES.i1} className="s14-i-2" />
          <Description className="small left">
            更有蔡司 Biotar 人像风格，再现
            <br />
            梦幻镜头旋转虚化效果。
          </Description>
        </div>
      </Grid.Column>
      <Grid.Column className="s14-b2-right">
        <div className="container-right" style={{ opacity: d1, transform: `translateY(${d2}%) scale(${d3}) translateZ(0)` }}>
          <Image paddingBottom="134.178%" src={IMAGES.i2} className="s14-i-3" />
          <Description className="small left">多种风格，随心选择</Description>
        </div>
      </Grid.Column>
    </Grid>
  );
}
